module.exports = __webpack_public_path__ + "static/img/85093B_1_C_20210117_LC.f808235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85093B_1_C_20210117_LC.png
// module id = hM9F
// module chunks = 0